var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12V17C1 18.1046 1.89543 19 3 19H8",
    stroke: "#18964E",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12V17C19 18.1046 18.1046 19 17 19H12",
    stroke: "#18964E",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1L3 1C1.89543 1 1 1.89543 1 3L1 8",
    stroke: "#18964E",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1L15.5 1L17 1C18.1046 1 19 1.89543 19 3L19 8",
    stroke: "#18964E",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11,
    width: 4,
    height: 4,
    rx: 0.5,
    stroke: "#18964E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 4,
    height: 4,
    rx: 0.5,
    stroke: "#18964E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 4,
    height: 4,
    rx: 0.5,
    stroke: "#18964E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5,
    width: 4,
    height: 4,
    rx: 0.5,
    stroke: "#18964E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrGreen);
export default __webpack_public_path__ + "static/media/qr-green.5f7d21c844d2dece7f7805f3c6eaaf18.svg";
export { ForwardRef as ReactComponent };